module.exports = {
	"edit.topic": "编辑帖子",
  "topic.title": "标题",
  "tip.input.title": "标题不能为空",
	"confirm.remove.topic": "确定要删除帖子吗",
	"confirm.remove.comment": "确定要删除评论吗",
	"reply.topic": "添加评论",
	"edit.comment": "编辑评论",
	"reply.to": "评论给",
	"my.comment": "我的回答",
	"post.comment": "立即发布",
	"relevant.topic": "相关帖子",
	"share.to": "分享到",
	"share.wx": "分享到微信朋友圈",
	"share.wx.action": "打开微信，点击底部的“发现”，使用 “扫一扫” 即可将网页分享到我的朋友圈。",
	"content.length": "你输入的内容过短",
	"tag": "标签",
	"topic.tag": "标签, 按回车键分隔",
	"tags.length": "标签内容不能超过{{max}}个字符",
  "tags.count": "标签个数不能超过{{max}}个",
  "comment.list": "评论列表",
  "copy.success": "复制成功",
  "make.answer": "设为答案",
  "top.answer": "最佳答案",
  "confirm.answer": "确定将该评论设为答案吗?",
  "answered": "已采纳",
  "official": "官方推荐"
}


// WEBPACK FOOTER //
// ./src/pages/topic/i18n/locale.zh-cn.js